@use '../../scss/utility/functions' as utility;

:host {
  display: inline-flex;
}

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  color: var(--wb-white);
  background: transparent;
  cursor: pointer;
  position: relative;
  text-decoration: none;
  min-width: utility.wb-pixel-to-rem(48px);
  min-height: utility.wb-pixel-to-rem(48px);
  appearance: none;
  background-color: transparent;
  padding: 0;
  margin: 0;
}

.button:hover {
  background-color: var(--wb-grey-15);
}

.button:focus-visible {
  outline: utility.wb-pixel-to-rem(1px) solid var(--wb-blue-45);
}

::slotted(.wb-icon) {
  --size: #{utility.wb-pixel-to-rem(16px)};
}

// TODO refactor once icons have been harmonised
::slotted(.wb-icon[name='bds/car/24']),
::slotted(.wb-icon[name='bds/close/24']) {
  --size: #{utility.wb-pixel-to-rem(24px)};
}

::slotted(img),
::slotted(.wb-aspect-ratio) {
  border-radius: var(--wb-radius-full);
  overflow: hidden;
  width: utility.wb-pixel-to-rem(20px);
  height: utility.wb-pixel-to-rem(20px);
}

::slotted(.wb-icon),
::slotted(img),
::slotted(.wb-aspect-ratio) {
  pointer-events: none;
}
